import type { ReactNode } from 'react';

import { SplashScreen } from '@/components/loading-screen';
import { useUiFeatureFlags } from '@/context/FeatureFlagsContext';
import NotFound from '@/pages/NotFound';

export function VendorFeatureGate({ children }: { children: ReactNode }) {
  const { flags, isLoading } = useUiFeatureFlags();

  if (isLoading) {
    return <SplashScreen />;
  }
  
  return flags.viewVendors ? <>{children}</> : <NotFound />;
}
